import React from "react";
import AnimatedFeatureSection from "../../component/common/AnimatedFeatureSection";

const WhyChooseUsSection = () => {
  // Define the specific data for this section
  const featuresData = [
    {
      icon: "/images/aboutImg/icon1.svg",
      title: "Protect the Environment",
      description:
        "Green energy significantly reduces greenhouse gas emissions and air pollution. By using renewable sources like biogas, we turn waste into clean energy while cutting methane emissions that would otherwise harm the climate.",
      // The unique margins are passed here via className
      className: "mb-[38px] 2xl:mb-[76px]",
    },
    {
      icon: "/images/aboutImg/icon2.svg",
      title: " Turn Waste Into Value",
      description:
        "Instead of sending organic waste to landfills, green energy solutions convert it into usable power. This supports a circular economy where resources are reused, not wasted.",
      className: "", // No margin
    },
    {
      icon: "/images/aboutImg/icon3.svg",
      title: " Reliable & Local Energy",
      description:
        "Unlike fossil fuels, green energy can be produced locally. Biogas provides stable, continuous power that reduces dependence on imported fuels and strengthens energy security.",
      className: "mb-[19px] 2xl:mb-[38px]",
    },
    {
      icon: "/images/aboutImg/icon4.svg",
      title: "Long-Term Cost Savings",
      description:
        "Renewable energy systems lower operating costs over time, protect against fuel price volatility, and create long-term economic value from waste streams that were once a liability.",
      className: "mb-[40px] 2xl:mb-[80px]",
    },
  ];

  return (
    <AnimatedFeatureSection
      subtitle="Why choose us"
      title="Why Choose Green Energy?"
      features={featuresData}
      // Optional: Overrides (defaults are already set to your original colors)
      bgColor="bg-[#1C233A]"
      textColor="text-text-secondary"
      lineColor="bg-text-secondary"
    />
  );
};

export default WhyChooseUsSection;
